import combineUrl from './combineUrl'

export default (path: string) => {
	if (typeof window !== 'undefined') {
		const { protocol, hostname, port } = window.location
		return combineUrl(`${protocol}//${hostname}${port ? ':' + port : ''}`, path)
	}
	return ''
}
